/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ex_IntroInputs */

const en_minifier_ex_intro = /** @type {(inputs: Minifier_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whitespace between tokens disappears. Whitespace inside a string value does not.`)
};

const ko_minifier_ex_intro = /** @type {(inputs: Minifier_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토큰 사이의 공백은 사라집니다. 문자열 값 안의 공백은 사라지지 않습니다.`)
};

const ja_minifier_ex_intro = /** @type {(inputs: Minifier_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トークンの間の空白は消えます。文字列値の中の空白は消えません。`)
};

/**
* | output |
* | --- |
* | "Whitespace between tokens disappears. Whitespace inside a string value does not." |
*
* @param {Minifier_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ex_intro = /** @type {((inputs?: Minifier_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ex_intro(inputs)
	if (locale === "ko") return ko_minifier_ex_intro(inputs)
	return ja_minifier_ex_intro(inputs)
});